import { Injectable } from '@angular/core';
import { FieldModel } from 'app/models/shared/field.model';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { TabModel } from 'app/models/shared/tab.model';
import { PriceEditorModel } from 'app/models/shared/priceEditor.model';
import { Constants } from 'app/utility/constants';

@Injectable({
    providedIn: 'root'
})
export class FormService
{

    constructor() { }


    public checkLookupChildren(fieldGroups: FieldGroupModel[], changedField: FieldModel, recursive: boolean = false)
    {

        for (let field_group_loop of fieldGroups)
        {
            for (let field_test of field_group_loop.fields)
            {
                // console.log(field_test.parent, '==', changedField.id);
                if (field_test.parent && field_test.parent == changedField.id)
                {
                    // console.log("found a child, " + field_test.id, field_test.toggleEditableWhen, changedField.editValue);


                    if (field_test.parentLookupId != changedField.editValue)
                    {
                        // console.log("Changing the child", field_test, changedField);
                        field_test.parentLookupId = changedField.editValue;

                        if (field_test.type == 'lookup')
                        {
                            field_test.editValue = '00000000-0000-0000-0000-00000000000';
                        }
                        else if (field_test.selected)
                        {
                            field_test.editValue = '';
                        }
                        if (field_test.hasChildren)
                        {
                            this.checkLookupChildren(fieldGroups, field_test, true);
                        }
                    }

                    //match on multiple options
                    if (field_test.toggleEditableWhen && field_test.toggleEditableWhen.indexOf('|') > -1)
                    {
                        // console.log("Toggle editable for field", field_test);
                        // console.log("changed field: ", changedField.editCaption);
                        // console.log("target field: ", field_test.toggleEditableWhen);
                        // console.log("comparison", (changedField.editCaption+'' == field_test.toggleEditableWhen+''));
                        if (field_test.toggleEditableWhen.indexOf(changedField.editCaption) > -1 ||
                            field_test.toggleEditableWhen.indexOf(changedField.value) > -1)
                        {
                            field_test.editable = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.editable = field_test.inverseCheck;
                        }
                        // console.log("Toggled to: ", field_test.editable);
                    }
                    else if (field_test.toggleEditableWhen && field_test.toggleEditableWhen != "")
                    {
                        // console.log("Toggle editable for field", field_test);
                        if (field_test.parentLookupId == field_test.toggleEditableWhen)
                        {
                            field_test.editable = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.editable = field_test.inverseCheck;
                        }
                        // console.log("Toggled to: ", field_test.editable);
                    }

                    //match on multiple options
                    if (field_test.toggleVisibleWhen && field_test.toggleVisibleWhen.indexOf('|') > -1 ||
                        field_test.toggleVisibleWhen && field_test.toggleVisibleWhen.indexOf('|') > -1)
                    {
                        // console.log("Toggle visible for field", field_test);
                        if (field_test.toggleVisibleWhen.indexOf(changedField.editCaption) > -1 ||
                            field_test.toggleVisibleWhen.indexOf(changedField.value) > -1)
                        {
                            field_test.viewInEdit = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.viewInEdit = field_test.inverseCheck;
                        }
                        // console.log("Toggled to: ", field_test.viewInEdit);
                    }
                    else if (field_test.toggleVisibleWhen && field_test.toggleVisibleWhen != "")
                    {
                        // console.log("Toggle visible for field", field_test);
                        // console.log("parentLookupId", field_test.parentLookupId);
                        // console.log("toggleVisibleWhen", field_test.toggleVisibleWhen);
                        if (field_test.parentLookupId == field_test.toggleVisibleWhen)
                        {
                            field_test.viewInEdit = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.viewInEdit = field_test.inverseCheck;
                        }
                        // console.log("Toggled to: ", field_test.viewInEdit);
                    }
                }
            }
        }
    }

    public static syncFormWithObject(field_groups: FieldGroupModel[], data: any): boolean
    {
        var data_changed = false;

        for (let field_group of field_groups)
        {
            for (let field of field_group.fields)
            {
                if (data[field.id] != null && (field.dirty || data[field.id] != field.value) && !field.invalid)
                {
                    data_changed = true;
                    if (!field.value && (field.type == "number" || field.type == "currency" || field.type == "decimal"))
                    {
                        field.value = 0;
                    }

                    if (field.type == "price")
                    {
                        let sideloadObject = field.detailObject as PriceEditorModel;
                        if (sideloadObject.taxType)
                        {
                            data[sideloadObject.taxType.id] = sideloadObject.taxType.value;
                        }
                        if (sideloadObject.taxRate)
                        {
                            data[sideloadObject.taxRate.id] = sideloadObject.taxRate.value;
                        }
                        if (sideloadObject.taxAmount)
                        {
                            data[sideloadObject.taxAmount.id] = sideloadObject.taxAmount.value;
                        }
                        if (sideloadObject.currency)
                        {
                            data[sideloadObject.currency.id] = sideloadObject.currency.value;
                        }
                    }

                    data[field.id] = field.value;
                }
                else
                {
                    if (field.editable && data[field.id] == null && field.type != "photo" && field.type != "signature")
                    {
                        console.error("Field not found in data set. Check tab has correct data sent through.", field.id);
                    }
                }
            }
        }
        return data_changed;
    }
}

